define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm/PostRequest",
	"csi/breadcrumb/StateActionController",
	"csi/breadcrumb/ReviseReopenController",
	"csi/widget/MessageDialog",
	"csi/locale"
], function(declare,lang,PostRequest,StateActionController,ReviseReopenController,MessageDialog,locale) {

	return declare(ReviseReopenController, {
		reopenConfirm: false,
		
		hasToConfirmAction: function() {
			this.reopenConfirm = this.getNode().$Type == "ApparelBOMRevision";
			return this.inherited(arguments) || this.reopenConfirm;
		},
		
		confirmAction: function(params) {
			if (this.reopenConfirm) {
				// summary: issue request so as to be able to receive return value
				this.setProgress();

				new PostRequest("MaterialSpec", "IsBOMRevisionPSEqualStyleSpecPS")
					.addParameter("ParentURL", this.m_urlNode)
					.post({}).then(lang.hitch(this, this._onValidatePSResponse));
			} else {
				this.inherited(arguments);
			}
		},
		
		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then check if it was confirmed
			if (this.reopenConfirm) {
				if (key == MessageDialog.BUTTON_REOPEN) {
					this.reopenConfirm = false;
					ReviseReopenController.prototype.confirmAction.call(this,null);
				} else {
					this.postProcess();
				}
			} else
				this.inherited(arguments);
		},
		
		_onValidatePSResponse: function(/*Response*/response) {
			if (response.getReturnValue()) {
				// ensure that base confirm is honored to display dialog if necessary
				this.reopenConfirm = false;
				ReviseReopenController.prototype.confirmAction.call(this,null);
			} else {
				StateActionController.prototype.confirmAction.call(this, {
                    materialIcon: MessageDialog.ICON_ERROR,
                    title: locale.resource("ReopenProductStructureTitle"),
                    buttons: [MessageDialog.BUTTON_REOPEN + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
                    message: locale.resource("ReopenProductStructurePrompt")
				});
			}
		}
	});
});